import UserApartmentModal from './UserApartmentModal';

export default UserApartmentModal;
